import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { STAGGER, useInView } from "../animationUtils";
import { PostCol } from "./blogPosts";
import BlogPostItem from "./blogPostItem";

export const fragments = graphql`
  fragment Page_ArticleGridByTags on PrismicPageDataBodyArticleGridByTags {
    id
    slice_type
    primary {
      article_grid_by_tag_title {
        text
      }
      tags {
        text
      }
      show_featured_image_on_grid
    }
    items {
      post_item {
        uid
        document {
          ... on PrismicMediumPost {
            id
            data {
              title {
                text
              }
              featured_image {
                alt
                gatsbyImageData(layout: CONSTRAINED, width: 600)
              }
              author {
                document {
                  ... on PrismicAuthor {
                    id
                    data {
                      name {
                        text
                      }
                      image {
                        alt
                        gatsbyImageData(layout: CONSTRAINED, width: 600)
                      }
                      position {
                        text
                      }
                    }
                  }
                }
              }
            }
            url
            tags
          }
        }
      }
    }
  }

  fragment FocusArea_ArticleGridByTags on PrismicFocusAreaDataBodyArticleGridByTags {
    id
    slice_type
    primary {
      article_grid_by_tag_title {
        text
      }
      tags {
        text
      }
      show_featured_image_on_grid
    }
    items {
      post_item {
        uid
        document {
          ... on PrismicMediumPost {
            id
            data {
              title {
                text
              }
              featured_image {
                alt
                gatsbyImageData(layout: CONSTRAINED, width: 600)
              }
              author {
                document {
                  ... on PrismicAuthor {
                    id
                    data {
                      name {
                        text
                      }
                      image {
                        alt
                        gatsbyImageData(layout: CONSTRAINED, width: 600)
                      }
                      position {
                        text
                      }
                    }
                  }
                }
              }
            }
            url
            tags
          }
        }
      }
    }
  }
`;

function ArticleGridByTags({
  data,
  title,
  showFeaturedImage,
  isFilteredByTags,
}) {
  const [ref, inView] = useInView();
  return (
    <motion.div
      ref={ref}
      {...STAGGER}
      {...(inView ? { animate: "start" } : {})}
      className="article-grid-by-tags blog-posts"
    >
      {data?.length > 0 && <h3 className="h3">{title}</h3>}
      <div className="article-grid-by-tags__row blog-posts__row">
        {isFilteredByTags
          ? data?.map(
              (item, i) =>
                i < 3 && (
                  <PostCol
                    key={i}
                    post={item?.node}
                    showFeaturedImage={showFeaturedImage}
                  />
                )
            )
          : data?.map(
              (item, i) =>
                i < 3 && (
                  <BlogPostItem
                    key={i}
                    post={item?.post_item}
                    showFeaturedImage={showFeaturedImage}
                  />
                )
            )}
      </div>
    </motion.div>
  );
}

export default ArticleGridByTags;
